<template>
  <div class="page-table scrollable only-y">
    <div class="no-table-box page-header">
      <el-row class="hidden-sm-and-up pb-15">
        <h1>
          <v-svg class="voxo-green" sprite="megaphone" />
          Routing Profiles
        </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="12">
          <h1>
            <v-svg class="voxo-green" sprite="megaphone" />
            Routing Profiles
          </h1>
        </el-col>
        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total }}
          </el-tag>
        </el-col>
      </el-row>
      <div class="flex pb-20">
        <div class="box">
          <el-input v-model="search" placeholder="Search" clearable />
        </div>
        <div class="box right">
          <el-button @click="openCreateModal">Add New</el-button>
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{enabled: true, gt: 50, oSize: 0}"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>

      <create-form
        :createVisible="createVisible"
        :createProcessing="createProcessing"
        :providerOptions="providerOptions"
        :clearFormFields="clearFormFields"
        @cancelOperation="cancelOperation"
        @createOperation="createOperation"
      />

      <edit-form
        :editVisible="editVisible"
        :editProcessing="editProcessing"
        :providerOptions="providerOptions"
        :clearFormFields="clearFormFields"
        :selectedRoutingProfile="selectedRoutingProfile"
        @cancelOperation="cancelOperation"
        @editOperation="editOperation"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { debounce } from 'lodash';
import CreateForm from "./components/createForm";
import EditForm from "./components/editForm";

import feathersClient from "../../../feathers/feathers-client";
import {globalEventBus} from "../../../globalEventBus";

export default {
  name: "RoutingProfilesTable",
  data() {
    return {
      eventChannel: null,
      providerOptions: [],
      tableLoading: false,
      selectedRoutingProfile: null,
      tableData: [],
      allProfiles: [],
      total: 0,
      search: "",
      visibleActionsId: "",
      editVisible: false,
      editProcessing: false,
      createVisible: false,
      createProcessing: false,
      clearFormFields: false,
      reRenderKey: "",
      tableColumns: [
        {
          field: "sprite",
          title: "",
          width: 50,
          slots: {
            default: ({ row }) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-green" sprite="megaphone" />
                </div>
              ];
            }
          }
        },
        {
          field: 'name',
          title: 'Name',
          sortable: true,
          minWidth: 150,
          showOverflow: true
        },
        {
          field: 'description',
          title: 'Description',
          minWidth: 175,
          sortable: true,
          showOverflow: true
        },
        {
          field: 'actions',
          title: '',
          minWidth: '150',
          showOverflow: false,
          slots: {
            default: ({row}) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={'edit-'+ row.id}
                    icon="el-icon-edit"
                    onClick={() => this.openEditModal(row.id)}
                    class="table-action-button icon-blue"
                  />
                  <el-button
                    id={'delete-'+row.id}
                    icon="el-icon-delete"
                    onClick={() => this.deleteOperation(row.id)}
                    class="table-action-button icon-red"
                  />
                </div>
              ]
            }
          }
        }
      ]
    };
  },

  components: {
    CreateForm,
    EditForm
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },

  watch: {
    user() {
      this.findProviders();
      this.findRoutingProfiles();
      if(!this.eventChannel){
        this.joinSocketChannel();
      }
    },
    search: debounce(function () {
      this.searchProfiles();
    }, 500)
  },

  methods: {
    ...mapActions("routing-profiles", {
      deleteRoutingProfiles: "remove",
      patchRoutingProfiles: "patch",
      createRoutingProfiles: "create"
    }),

    searchProfiles() {
      if(this.search.length){
        this.tableData = this.allProfiles.filter(
          data =>
            data.name.toLowerCase().includes(this.search.toLowerCase())
        );
      } else{
        this.tableData = [...this.allProfiles];
      }
      this.total = this.tableData.length;
    },

    openCreateModal() {
      this.createVisible = true;
      this.clearFormFields = false;
    },

    openEditModal(id) {
      feathersClient
        .service("routing-profiles")
        .get(id)
        .then(res => {
          this.selectedRoutingProfile = { ...res };
          this.editVisible = true;
        });
      this.clearFormFields = false;
    },

    //General Form and Table Operations
    cellClicked(data) {
      if(data.column.property !== 'actions'){
        this.openEditModal(data.row.id);
      }
    },

    rowHover(data){
      this.visibleActionsId = data.row.id;
    },

    rowLeave(){
      this.visibleActionsId = "";
    },


    findRoutingProfiles(){
      this.tableLoading = true;
      feathersClient.service('routing-profiles').find().then(res => {
        this.tableData = [...res];
        this.allProfiles = [...res];
        this.total = res.length;
        this.tableLoading = false;
      }).catch( () => {
        this.tableLoading = false;
      })
    },

    // ⭐️ Create Operation ⭐️ //
    createOperation(createBody) {
      this.$confirm("Process Routing Profile Create?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.createProcessing = true;

          this.createRoutingProfiles(createBody)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Created Successfully!",
                type: "success"
              });
              this.createProcessing = false;
              this.cancelOperation("create");
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
              this.createProcessing = false;
              this.clearFormFields = false;
            });
        })
        .catch(() => true);
    },

    // ⭐️ Edit Operation ⭐️ //
    editOperation(editBody) {
      this.$confirm("Process Routing Profile Edit?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.editProcessing = true;

          this.patchRoutingProfiles([this.selectedRoutingProfile.id, editBody])
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Edited Successfully!",
                type: "success"
              });
              this.editProcessing = false;
              this.cancelOperation("edit");
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
              this.editProcessing = false;
              this.clearFormFields = false;
            });
        })
        .catch(() => true);
    },

    // ⭐️ Delete Operation ⭐️ //
    deleteOperation(id) {
      this.$confirm("Process Routing Profile Delete?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.tableLoading = true;
          this.deleteRoutingProfiles(id)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Deleted Successfully!",
                type: "success"
              });
              this.tableLoading = false;
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
              this.tableLoading = false;
            });
        })
        .catch(() => true);
    },

    // ⭐️ Cancel Operation ⭐️ //
    cancelOperation(type) {
      if (type === "create") {
        this.createVisible = false;
        this.clearFormFields = true;
      } else if (type === "edit") {
        this.editVisible = false;
        this.clearFormFields = true;
      }
    },

    findProviders(){
      feathersClient.service('providers').find({
        query: {
          $sort: {name: 1}
        }
      }).then(res => {
        this.providerOptions = [...res];
      });
    },

    joinSocketChannel(){
      const channelService = feathersClient.service('channel-memberships');
      const data = {
        roomType: 'global-admins'
      }
      channelService.create(data).then(res => {this.eventChannel = 'global-admins'});
    },

    removeListeners(){
      feathersClient.service('routing-profiles').removeListener('patched');
      feathersClient.service('routing-profiles').removeListener('created');
      feathersClient.service('routing-profiles').removeListener('removed');
      globalEventBus.$off('appReconnected');
    }
  },

  mounted() {
    if (this.user) {
      this.findRoutingProfiles();
      this.findProviders();
      this.joinSocketChannel();
    }
  },

  created() {
    //event listeners
    //monitor socket connection and reconnect to channel
    globalEventBus.$on('appReconnected', () => {
      this.joinSocketChannel();
    });

    //record was edited
    //always refresh did destination options
    feathersClient.service('routing-profiles').on('patched', (data) => {
      const updateIndex = this.tableData.findIndex(item => item.id === data.id);
      const updateAllIndex = this.allProfiles.findIndex(item => item.id === data.id);
      if(updateIndex >= 0){this.tableData.splice(updateIndex, 1, data);}
      if(updateAllIndex >= 0){ this.allProfiles.splice(updateAllIndex, 1, data);}
    });

    //record was created
    feathersClient.service('routing-profiles').on('created', (data) => {
      this.tableData.push(data);
      this.allProfiles.push(data);
    });

    //record was deleted
    feathersClient.service('routing-profiles').on('removed', (data) => {
      const indexToRemove = this.tableData.findIndex(item => item.id === data.id);
      const indexAllToRemove = this.allProfiles.findIndex(item => item.id === data.id);
      if(indexToRemove >= 0){this.tableData.splice(indexToRemove, 1);}
      if(indexAllToRemove >= 0){this.allProfiles.splice(indexAllToRemove, 1);}
    });
  },
  beforeDestroy() {
    this.removeListeners();
    feathersClient.service('channel-memberships').remove(null, {query: {channelName: this.eventChannel}});
  }
};
</script>
